import Button from '../../Button'
import { Container } from '../Container'

import { INLINE_BUTTON_SIZES } from './Buttons.constants'

import * as styles from './Buttons.module.css'

import PlusIcon from '../../../icons/plus.svg'

export function Icon() {
  return (
    <>
      <Container label='Button, icon, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Icon
            Icon={PlusIcon}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, icon, disabled, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Icon
            disabled
            Icon={PlusIcon}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, icon, with loader, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Icon
            isLoading
            Icon={PlusIcon}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, icon, with skeleton, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Icon
            isSkeleton
            Icon={PlusIcon}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
    </>
  )
}
